module.exports = __webpack_public_path__ + "static/media/gt-exhaust-logo-cover.76852b2b.jpg";